export const SearchProviderInputComponent = {
  templateUrl:
    './app/ajs/_shared/components/search-provider-input/search-provider-input.component.html',
  bindings: {
    provider: '<',
    providerSelected: '&',
    providerValidated: '&',
    providerCleared: '&',
    placeholder: '<',
    isRequired: '<',
    isDisabled: '<',
  },
  controller: SearchProviderInputController,
  controllerAs: 'vm',
};

SearchProviderInputController.$inject = ['ProviderService'];

function SearchProviderInputController(ProviderService) {
  const vm = this;

  // public methods
  // -----------------------
  vm.searchProvider = function (search) {
    if (search.length < 2) return;

    const params = {
      get: 'active',
      by_provider: search,
      skip_check_role: true,
    };

    return ProviderService.getProviders(params).then(function (data) {
      if (data.items.length === 0) {
        vm.providerCleared({ $clearObj: false });
      }

      return data.items;
    });
  };

  vm.selectProvider = function (provider) {
    // console.log('selectProvider');
    // console.log(provider);
    vm.providerSelected({ $event: provider });
  };

  vm.validateProvider = function () {
    // console.log('validateProvider');
    // console.log(vm.provider);
    vm.providerValidated({ $event: vm.provider });
  };

  vm.clearProvider = function () {
    // console.log('clearProvider');
    // vm.provider = null;

    vm.providerCleared({ $clearObj: true });
  };
}
